import React, { useState, useEffect } from "react"
import { Row, Col, Carousel, Input } from "antd"

import searchIcon from "../../assets/images/ic_search_24px.svg"
import meetingImage from "../../assets/images/meeting.png"
import brandLogo from "../../assets/images/brands/go_logo.png"
import CrownePlazaManila from "../../assets/images/searchmeetingplace/CrownePlazaManila.jpg"
import GrandSummitHotel from "../../assets/images/searchmeetingplace/GrandSummitHotel.png"
import SummitHotelTacloban from "../../assets/images/searchmeetingplace/SummitHotelTacloban.jpg"
import SummitGalleriaCebu from "../../assets/images/searchmeetingplace/SummitGalleriaCebu.jpg"
import DusitThaniMactanCebu from "../../assets/images/searchmeetingplace/DusitThaniMactanCebu.jpg"
import FiliHotelCebu from "../../assets/images/searchmeetingplace/fili-hotel-cebu.png"
import WestinBallroomMandaluyong from "../../assets/images/searchmeetingplace/westin-ballroom.jpg"
import CrownPlazaThird from "../../assets/images/searchmeetingplace/crown-plaza-third.jpg"
import GrandSummitFourth from "../../assets/images/searchmeetingplace/grand-summit-fouth.jpg"
import SummitGalleriaFifth from "../../assets/images/searchmeetingplace/summit-galleria-fifth.jpg"
import { HomePageI, HotelI } from "../../interface"

import "./SearchMeetingPlace.scss"
import Markdown from "markdown-to-jsx"
import homePageDatas from "../FeaturedContent/FeaturedContents"

const { Search } = Input

const SearchMeetingPlace = ({ data }) => {
  const [search, setSearch] = useState("")
  const [result, setResults] = useState<HotelI[]>([])
  const [searchResult, setSearchResult] = useState<boolean>(false)
  const [noResult, setNoResult] = useState<boolean>(false)

  useEffect(() => {
    data.tarsiergraphql.getHotels.sort((a, b) => a.name.localeCompare(b.name))
    setResults(data.tarsiergraphql.getHotels)
  })

  const onSearch = (val: string, e) => {
    if (typeof window !== "undefined") {
      Array.from(document.querySelectorAll(".search-hotel-wrap")).forEach(el =>
        el.classList.remove("active")
      )
    }
    if (val) {
      setTimeout(() => {
        const res = result
          .filter(
            res =>
              ((res.name !== "" &&
                res.name
                  .toLocaleLowerCase()
                  .includes(val.toLocaleLowerCase())) ||
              (res.address !== "" &&
                res.address
                  .toLocaleLowerCase()
                  .includes(val.toLocaleLowerCase()))) &&
              (res.brand.status.toLowerCase() === "published")
          )
          .map((v, k) => {
            return v
          })

        if (res.length === 0) {
          setSearch(val.toLocaleLowerCase())
          setSearchResult(false)
          setNoResult(true)
          return
        }

        if (res.length !== 0) {
          setSearch(val.toLocaleLowerCase())
          setResults(result)
          setNoResult(false)
          setSearchResult(true)
          return
        }
      }, 600)
    }

    if (val === "") {
      setSearch("")
      setSearchResult(false)
      setNoResult(false)
      return
    }
  }

  const getHotelsDetails = (id: string) => {
    if (typeof window !== "undefined") {
      const ele = document.getElementById("search-result-" + id)

      if (ele?.classList.contains("active")) {
        ele?.classList.remove("active")
        return
      }
      setSearchResult(false)
      ele?.classList.add("active")
      return
    }
  }

  const closeResult = () => {
    setNoResult(false)
    setSearchResult(false)
  }

  const onErrorImg = e => {
    e.target.src = brandLogo
  }

  const [homePageData, sethomePageData] = useState<HomePageI>()

  useEffect(() => {
    if (data?.tarsiergraphql?.getHomepageDetails) {
      sethomePageData(data.tarsiergraphql.getHomepageDetails)
    }
  }, [data])

  const [title, setTitle] = useState("")
  const [subheader, setSubheader] = useState("")

  useEffect(() => {
    const sanitizeContent = async () => {
      if (typeof window === "undefined") return

      const mod = await import("dompurify")
      const createDOMPurify = mod.default || mod
      const DOMPurify = createDOMPurify(window)

      setTitle(DOMPurify.sanitize(homePageData?.meetings_title ?? ""))
      setSubheader(DOMPurify.sanitize(homePageData?.meetings_sub_header ?? ""))
    }

    sanitizeContent()
  }, [homePageData])

  return (
    <div className="search-meeting-container">
      <Row>
        <Col xl={12} xs={27} className="search-meeting-details-wrap">
          <div className="search-meeting-details">
            <article>
              <h5 className="title">
                {homePageData?.meetings_pre_header ?? ""}
              </h5>
              <Markdown
                options={{
                  overrides: {
                    p: {
                      component: "h2",
                      props: { className: "title-border" },
                    },
                  },
                }}
              >
                {title}
              </Markdown>
              <Markdown>{subheader}</Markdown>
            </article>
            <div className="search-meeting-form">
              <span className="title">Search Hotels & Locations</span>
              <Search
                placeholder="e.g Summit, Go Hotels, Tacloban, Cebu"
                allowClear
                enterButton={<img src={searchIcon} alt="Search" />}
                size="large"
                onSearch={onSearch}
              />
            </div>
          </div>
        </Col>
        <Col xs={30} xl={12}>
          <div
            className="search-hotel-wrap no-result-hotels"
            style={noResult ? {} : { display: "none" }}
          >
            <span
              className="close-search-result rhr-close-button"
              onClick={closeResult}
            ></span>
            <h3>Search Results</h3>
            <span>
              Ooops! No results {search === "" ? "found." : `for "${search}"`}
            </span>
          </div>
          <div
            className="search-hotel-wrap search-result"
            style={searchResult ? {} : { display: "none" }}
          >
            <span
              className="close-search-result rhr-close-button"
              onClick={closeResult}
            ></span>
            <h3>Search Results</h3>
            <ul>
              {result
                .filter(
                  res =>
                    ((res.name !== "" &&
                      res.name
                        .toLocaleLowerCase()
                        .includes(search.toLocaleLowerCase())) ||
                    (res.address !== "" &&
                      res.address
                        .toLocaleLowerCase()
                        .includes(search.toLocaleLowerCase()))) &&
                    (res.brand.status.toLowerCase() === "published")
                )
                .map((res, key) => (
                  <li key={key} onClick={() => getHotelsDetails(res.id)}>
                    {res.name}
                  </li>
                ))}
            </ul>
          </div>
          {result
            .filter(res => res.name !== "")
            .map((res, key) => (
              <div
                key={key}
                id={`search-result-${res.id}`}
                className={`search-hotel-wrap specific-item`}
              >
                <span
                  className="close-search-result rhr-close-button"
                  onClick={() => getHotelsDetails(res.id)}
                ></span>
                <img
                  src={res.website_logo}
                  onError={onErrorImg}
                  alt={res.name}
                />
                <h3>{res.name}</h3>
                <span>ADDRESS: {res.address}</span>
                <Row>
                  <Col span={12} style={{ textAlign: "left" }}>
                    <a
                      href={res.website_link}
                      className="rhr-button"
                      target="_blank"
                    >
                      KNOW MORE
                    </a>
                  </Col>
                  <Col span={12}>
                    <a
                      href={res.request_for_proposal_link}
                      target="_blank"
                      className="request-hotel-proposal"
                    >
                      Request for proposal
                    </a>
                  </Col>
                </Row>
              </div>
            ))}
          ;
          <Carousel className="meeting-carousel carousel-dots-custom">
            {homePageData?.meetings_media.map(media => {
              return (
                <div className="meeting-wrap">
                  <div className="meeting-image">
                    <img
                      src={media.image}
                      className="img-responsive"
                      alt="Meeting"
                    />
                  </div>
                  <div className="meeting-image-details">
                    <article>
                      <p>{media.title}</p>
                      <span>{media.description}</span>
                      <span>{media.location}</span>
                    </article>
                  </div>
                </div>
              )
            })}
          </Carousel>
        </Col>
      </Row>
    </div>
  )
}

export default SearchMeetingPlace
